module.exports = __webpack_public_path__ + "static/media/about-us-bg-responsive.22237b51.png";